import Notiflix from 'notiflix';

Notiflix.Notify.init({
  position: 'center-top',
  clickToClose: true,
  pauseOnHover: false,
  cssAnimationStyle: 'from-top',
});
